import { classnames } from 'Utils/classnames/classnames.utils';

const defaultTheme = ({ isActive, isDisabled, isFilled }) => {
  const hasDefaultStyle = !isActive && !isFilled && !isDisabled;
  const hasFilledStyle = isFilled && !isDisabled;
  const hasActiveStyle = isActive && !isDisabled && !isFilled;

  return {
    thRoot: classnames(
      'flex w-full items-center rounded-pill border text-14 leading-normal text-black transition-all duration-250 ease-in',
      {
        'border-lightGrey hocus:border-black': hasDefaultStyle,
        'border-black': hasActiveStyle,
        'border-success text-black': hasFilledStyle,
        'cursor-not-allowed border-grey bg-pearl text-grey': isDisabled,
      },
    ),
    thButton: 'flex gap-10 items-center flex-1 h-48 px-20 py-10',
    thIcon: classnames('flex-none shrink-0', {
      'text-success': isFilled,
    }),
    thIconSize: '1.25em',
    thChildren: 'flex-1 text-initial',
    thBadge: 'size-24 text-black bg-saffron border-saffron',
    thIconRight: 'leading-0 pe-20 py-10 shrink-0',
    thSpinner: 'shrink-0 text-current',
    thIconCaret: 'transition-all duration-250 ease-in',
    thClear: 'leading-0 pe-20 py-10 shrink-0',
    thClearSize: '0.625rem',
    thSwitchButton: 'leading-0 pe-20 py-10 shrink-0',
    thSwitch: classnames(
      'flex h-24 w-40 overflow-hidden rounded-pill border-current bg-current p-2 leading-0 transition-all duration-250 ease-in',
      {
        'text-lightGrey': !isFilled,
        'text-success': isFilled,
      },
    ),
    thSwitchToggler: classnames(
      'flex size-20 items-center justify-center rounded-pill bg-white text-center text-10 font-bold leading-0 shadow',
      {
        'text-lightGrey': !isFilled,
        'transform text-success ltr:translate-x-[16px] rtl:-translate-x-[16px]': isFilled,
      },
    ),
  };
};

export const themes = (props) => {
  const d = defaultTheme(props);

  return {
    default: d,
    remote: {
      ...d,
      thButton: 'flex gap-5 items-center justify-center flex-1 h-48 p-10',
      thChildren: 'text-initial',
      thBadge: 'hidden',
      thClear: 'hidden',
      thIconRight: 'hidden',
      thSwitchButton: 'hidden',
    },
  };
};
